import React from 'react';
import { motion } from 'framer-motion';
export function TeamsGrid() {
  const teams = ['Argentina', 'Brasil', 'Francia', 'Portugal', 'España', 'México', 'Colombia', 'Inglaterra', 'Ecuador', 'Holanda', 'Japón', 'Alemania', 'Italia', 'Uruguay', 'Estados Unidos', 'Canadá', 'Marruecos', 'Senegal'];
  return <section className="py-20 bg-wc-dark text-white overflow-hidden" data-id="element-279">
      <div className="container mx-auto px-4 max-w-6xl text-center" data-id="element-280">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-281">
          <h2 className="text-4xl md:text-5xl text-wc-yellow mb-6" data-id="element-282">
            💥 LOS EQUIPOS QUE VAS A TENER COMPLETOS
          </h2>
        </motion.div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 mb-12" data-id="element-283">
          {teams.map((team, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.05
        }} className="bg-white/10 hover:bg-wc-blue border border-white/20 px-6 py-3 rounded-full text-lg font-medium transition-colors cursor-default" data-id="element-284">
              {team}
            </motion.div>)}
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: teams.length * 0.05
        }} className="bg-wc-red px-6 py-3 rounded-full text-lg font-bold" data-id="element-285">
            y todos los clasificados al Mundial 2026
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-3xl font-display tracking-wide text-gray-300" data-id="element-286">
          Ningún equipo te va a faltar.{' '}
          <span className="text-white" data-id="element-287">
            Ninguna figurita te va a quedar sin pegar.
          </span>
        </motion.div>
      </div>
    </section>;
}